export enum EOtpReason {
    TwoFA = "TwoFA",
    ResetPassword = "ResetPassword",
    VerifyMobile = "VerifyMobile",
    VerifyEmail = "VerifyEmail"
}